<template>
    <h4 class="bg-success p-3 rounded text-white text-center fw-bold">{{ $t('Personal Details') }}</h4>
    <div class="row mt-5">
        <div class="col-md-6">
            <b-form-group
                    id="firstname"
                    :label="$t('First Name')"
                    label-for="firstname"
                    label-cols="3"
                    label-align="right"
                    class="requiredField"
            >
                <b-form-input
                        type="text"
                        class="form-control"
                        v-model="userProfileData.firstName"
                        :placeholder="$t('First Name')"
                        name="firstname"
                        :state="getInputState(userProfileData.firstName)"
                        required
                ></b-form-input>

                <b-form-invalid-feedback v-if="showError(userProfileData.firstName)">
                    First name is required.
                </b-form-invalid-feedback>
            </b-form-group>
        </div>
        <div class="col-md-6">
            <b-form-group
                    id="lastname"
                    :label="$t('Last Name')"
                    label-for="firstname"
                    label-cols="3"
                    class="requiredField"
            >
                <b-form-input
                        type="text"
                        v-model="userProfileData.lastName"
                        class="form-control"
                        :placeholde="$t('Last Name')"
                        name="lastname"
                        :state="getInputState(userProfileData.lastName)"
                        required
                >
                </b-form-input>
                <b-form-invalid-feedback v-if="showError(userProfileData.lastName)">
                    Last name is required.
                </b-form-invalid-feedback>
            </b-form-group>
        </div>
        <div class="col-md-6">
            <b-form-group
                    id="marital_status"
                    :label="$t('Marital Status')"
                    label-cols="3"
                    label-for="marital_status"
                    class="requiredField"
            >
                <b-form-select
                        v-model="userProfileData.maritalStatusId"
                        :options="maritalOptions"
                        class="mb-3"
                        value-field="maritalId"
                        text-field="maritalType"
                        disabled-field="notEnabled"
                        :state="getInputState(userProfileData.maritalStatusId)">

                    <option :value="null" selected>-- {{ $t('Select One') }} --</option>
                </b-form-select>

                <b-form-invalid-feedback v-if="showError(userProfileData.maritalStatusId)">
                    Marital Status is required.
                </b-form-invalid-feedback>
            </b-form-group>
        </div>
        <div class="col-md-6">
            <b-form-group
                    id="profession"
                    :label="$t('Profession')"
                    label-cols="3"
                    label-for="profession"
            >
                <b-form-select
                        id="profession"
                        v-model="userProfileData.professionId"
                        :options="professionOption"
                        type="text"
                        :placeholder="$t('Profession')"
                        value-field="professionId"
                        text-field="profession"
                >
                    <option :value="null" selected>-- {{ $t('Select One') }} --</option>
                </b-form-select>
            </b-form-group>
        </div>
        <div class="col-md-6">
            <b-form-group
                    id="birthplace"
                    label-cols="3"
                    :label="$t('Place Of Birth')"
                    label-for="birthplace"
                    class="requiredField"
            >
                <b-form-select
                        type="text"
                        class="form-control"
                        v-model="userProfileData.nationality"
                        :options="placeOfBirth"
                        :placeholder="$t('Place Of Birth')"
                        value-field="countryId"
                        text-field="country"
                        :state="getInputState(userProfileData.nationality)"
                >
                    <option :value="null" selected>-- {{ $t('Select One') }} --</option>
                </b-form-select>
                    <b-form-invalid-feedback v-if="showError(userProfileData.nationality)">
                        Nationality is required.
                    </b-form-invalid-feedback>
            </b-form-group>
        </div>
        <div class="col-md-6">
            <b-form-group
                    id="district"
                    label-cols="3"
                    :label="$t('District/State')"
                    label-for="district"
            >
                <b-form-input
                        type="text"
                        class="form-control"
                        v-model="userProfileData.district"
                        :placeholder="$t('District/State')"
                >
                </b-form-input>
            </b-form-group>
        </div>
        <div class="col-md-6">
            <b-form-group :label="$t('Gender')" label-cols="3" label-for="gender">
                <b-form-select
                        v-model="userProfileData.gender"
                        :options="genderOptions"
                        :placeholder="$t('Gender')"
                        value-field="genderId"
                        text-field="gender"
                        class="form-control"
                        :state="getInputState(userProfileData.gender)"
                >
                    <option :value="null" selected>-- Select Gender --</option>
                </b-form-select>
                <b-form-invalid-feedback v-if="showError(userProfileData.gender)">
                    Gender is required.
                </b-form-invalid-feedback>
            </b-form-group>
        </div>

        <!-- NID/Passport -->
        <div class="col-md-6">
            <b-form-group :label="$t('NID/Passport')" label-cols="3" label-for="passport" class="requiredField">
                <b-form-input
                        v-model="userProfileData.nid"
                        :placeholder="$t('NID/Passport')"
                        type="text"
                        class="form-control"
                        :state="getInputState(userProfileData.nid)"
                        required
                >
                </b-form-input>
                <b-form-invalid-feedback v-if="showError(userProfileData.nid)">
                    NID No is required.
                </b-form-invalid-feedback>
            </b-form-group>
        </div>
        <div class="col-md-6" v-if="userProfileData.nid">
            <b-form-group
                    :label="$t('NID/Passport Documents')"
                    label-for="profile-photo"
                    class="profile-photo"
                    label-cols="3"
            >
                <div class="d-flex align-items-center">
                    <input
                            type="file"
                            ref="fileinput"
                            name="nidFileAttachment"
                            @change="nidFileAttachment"
                            class="form-control form-control-md me-2"
                            style="width: 90%;"
                    />
                    <button
                            class="btn btn-success"
                            @click="downloadFile(userProfileData.nidPaperUrl, 'NID File')"
                            v-if="userProfileData.nidPaperUrl"
                            style="white-space: nowrap;"
                    >
                        <font-awesome-icon class="text-white" :icon="['fas', 'download']"/>
                    </button>
                </div>
                <span style="font-size: 10px" class="text-danger">{{$t('Only PDF JPEG PNG')}}</span>
            </b-form-group>
        </div>

        <!-- TIN -->
        <div class="col-md-6">
            <b-form-group :label="$t('TIN')" label-cols="3" label-for="tin">
                <b-form-input
                        v-model="userProfileData.tin"
                        :placeholder="$t('TIN')"
                        type="text"
                        class="form-control"
                >
                </b-form-input>
            </b-form-group>
        </div>
        <div class="col-md-6" v-if="userProfileData.tin">
            <b-form-group
                    :label="$t('TIN Documents')"
                    label-for="profile-photo"
                    class="profile-photo"
                    label-cols="3"
            >
                <div class="d-flex align-items-center">
                    <input
                            type="file"
                            ref="fileinput"
                            name="reviewAttachment"
                            @change="tinFileAttach"
                            class="form-control form-control-md me-2"
                            style="width: 90%;"
                    />
                    <button
                            class="btn btn-success"
                            @click="downloadFile(userProfileData.tinPaperUrl, 'Tin File')"
                            v-if="userProfileData.tinPaperUrl"
                            style="white-space: nowrap;"
                    >
                        <font-awesome-icon class="text-white" :icon="['fas', 'download']"/>
                    </button>
                </div>
                <span style="font-size: 10px" class="text-danger">{{$t('Only PDF JPEG PNG')}}</span>
            </b-form-group>
        </div>

        <div class="col-md-6">
            <b-form-group
                    :label="$t('Profile Photo')"
                    label-for="profile-photo"
                    class="profile-photo"
                    label-cols="3"
            >
                <div class="d-flex align-items-center">
                    <input
                            type="file"
                            ref="fileinput"
                            name="profilePhoto"
                            @change="profilePhotoAttach"
                            class="form-control form-control-md me-2"
                            style="width: 90%;"
                    />
                    <button
                            class="btn btn-success"
                            @click="downloadFile(userProfileData.profilePictureUrl, 'Profile File')"
                            v-if="userProfileData.profilePictureUrl"
                            style="white-space: nowrap;"
                    >
                        <font-awesome-icon class="text-white" :icon="['fas', 'download']"/>
                    </button>
                </div>
                <span style="font-size: 10px" class="text-danger">{{$t('Only PDF JPEG PNG')}}</span>
            </b-form-group>
        </div>

        <!--<div class="col-md-6">
            <b-form-group
                    label="Profile Photo"
                    label-for="profile-photo"
                    class="profile-photo"
                    label-cols="3"
            >
                <input
                        type="file"
                        ref="fileinput"
                        name="profilePhoto"
                        @change="profilePhotoAttach"
                        class="form-control form-control-md"
                />
                <span style="font-size: 10px" class="text-danger">{{$t('Only PDF JPEG PNG')}}</span>
            </b-form-group>
            <button class="bg-success rounded-2 border-2" @click="downloadFileFromUrl(userProfileData.profilePictureUrl, 'NID File')" v-if="userProfileData.profilePictureUrl">
                <span>
                    <font-awesome-icon class="text-white" :icon="['fas', 'download']" />
                </span>
            </button>
        </div>-->

        <!-- Multiple Citizenship -->
        <div class="col-md-6">
            <b-form-group
                    id="multiple_citizenship"
                    label-cols="3"
                    :label="$t('Multiple Citizenship')"
                    label-for="multiple_citizenship"
            >
                <b-form-select
                        type="text"
                        class="form-control"
                        v-model="userProfileData.multipleCitizenCode"
                        :options="placeOfBirth"
                        :placeholder="$t('Multiple Citizenship')"
                        value-field="countryId"
                        text-field="country"
                >
                    <option :value="null" selected>-- {{ $t('Select One') }} --</option>
                </b-form-select>
            </b-form-group>
        </div>

        <!-- Citizenship Passport No -->
        <div class="col-md-6" v-if="userProfileData.multipleCitizenCode">
            <b-form-group
                    :label="$t('Citizenship Passport No')"
                    label-cols="3"
                    label-for="citizenPassport"
            >
                <b-form-input
                        v-model="userProfileData.multipleCitizenPassportNo"
                        :placeholder="$t('Citizenship Passport No')"
                        type="text"
                        class="form-control"
                >
                </b-form-input>
            </b-form-group>
        </div>
        <div class="col-md-6" v-if="userProfileData.multipleCitizenPassportNo">
            <b-form-group
                    :label="$t('Citizenship Document')"
                    label-for="profile-photo"
                    class="profile-photo"
                    label-cols="3"
            >
                <div class="d-flex align-items-center">
                    <input
                            type="file"
                            ref="fileinput"
                            name="citizenshipAttachmentName"
                            @change="citizenshipAttachment"
                            class="form-control form-control-md me-3"
                            style="width: 90%"
                    />
                    <button
                            class="btn btn-success"
                            @click="downloadFile(userProfileData.passportPaperUrl, 'Passport File')"
                            v-if="userProfileData.passportPaperUrl"
                            style="white-space: nowrap;"
                    >
                        <font-awesome-icon class="text-white" :icon="['fas', 'download']"/>
                    </button>
                </div>
                <span style="font-size: 10px" class="text-danger">{{$t('Only PDF JPEG PNG')}}</span>
            </b-form-group>
        </div>
    </div>
</template>

<script>
    import apiRepository, {getMedia} from "@/services/ApiRepository";
    import {toast} from "vue3-toastify";

    export default {
        name: "Profile-StepOne",
        props: ["formData"],
        data() {
            return {
                userProfileData: {
                    ...this.formData,
                    profileFile: null,
                    tinFile: null,
                    nidFile: null,
                    passportFile: null,
                    maritalStatusId: null,
                    professionId: null,
                    nationality: null,
                    multipleCitizenCode: null,
                    multipleCitizenPassportNo: null,
                    gender: null,
                    firstName: '',
                    lastName: '',
                },
                maritalOptions: [],
                professionOption: [],
                placeOfBirth: [],
                genderOptions: [],
                /* firstNameTouched: false,
                 lastNameTouched: false,
                 genderTouched: false,*/
            };
        },
        mounted() {
            this.maritalData();
            this.professionData();
            this.countryData();
            this.genderData();
            this.getProfileData();
        },
        watch: {
            userProfileData: {
                deep: true,
                handler(newValue) {
                    this.$emit("update:formData", newValue);
                },
            },
        },
        computed: {},
        methods: {
            getProfileData() {
                try {
                    apiRepository.userDataGet().then((response) => {
                        if (response) {
                            this.userProfileData = response.data.userProfile
                        } else {
                            console.error('Data not Found!!')
                        }
                    })
                } catch (e) {
                    toast.error('Invalid Request !', e)
                }
            },
            profilePhotoAttach(event) {
                const file = event.target.files[0];

                if (file) {
                    let reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = () => {
                        this.userProfileData.profileFile = reader.result;
                        console.log('profileFile', this.profileFile)
                    };
                }
            },

            tinFileAttach(event) {
                const file = event.target.files[0];

                if (file) {
                    let reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = () => {
                        this.userProfileData.tinFile = reader.result;
                    };
                }
            },
            nidFileAttachment(event) {
                const file = event.target.files[0];

                if (file) {
                    let reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = () => {
                        this.userProfileData.nidFile = reader.result;
                    };
                }
            },

            async downloadFile(url, filename) {
                // Normalize some MIME subtype extensions (optional)
                const specialMimeExtMap = {
                    jpeg: "jpg",
                    msword: "doc",
                    "vnd.openxmlformats-officedocument.wordprocessingml.document": "docx",
                    "vnd.ms-excel": "xls",
                    "vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx",
                    "vnd.ms-powerpoint": "ppt",
                    "vnd.openxmlformats-officedocument.presentationml.presentation": "pptx",
                    "x-7z-compressed": "7z"
                    // Add more if needed
                };

                try {
                    const response = await fetch(getMedia() + url);
                    if (!response.ok) {
                        throw new Error(`Failed to fetch file: ${response.status} ${response.statusText}`);
                    }

                    const data = await response.json();

                    // Decode base64 content
                    const byteCharacters = atob(data.content);
                    const byteNumbers = Array.from(byteCharacters, char => char.charCodeAt(0));
                    const byteArray = new Uint8Array(byteNumbers);

                    // Determine correct content type
                    let contentType = data.contentType || "";
                    let fileExt = "";

                    if (contentType.includes('/')) {
                        // Extract subtype after '/'
                        fileExt = contentType.split('/')[1].split(';')[0].trim().toLowerCase();

                        // Normalize extension if needed
                        if (fileExt in specialMimeExtMap) {
                            fileExt = specialMimeExtMap[fileExt];
                        }
                    }

                    // If filename doesn't already end with this extension, append it
                    if (fileExt && !filename.toLowerCase().endsWith(`.${fileExt}`)) {
                        filename += `.${fileExt}`;
                    }

                    // Create Blob
                    const blob = new Blob([byteArray], { type: contentType || "application/octet-stream" });

                    // Trigger download
                    const blobUrl = URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = blobUrl;
                    link.download = filename;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    URL.revokeObjectURL(blobUrl);

                } catch (error) {
                    console.error("Download failed:", error);
                }
            },

            citizenshipAttachment(event) {
                const file = event.target.files[0];

                if (file) {
                    let reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = () => {
                        this.userProfileData.passportFile = reader.result;
                        console.log('citizenFile', this.passportFile)
                    };
                }
            },
            maritalData() {
                apiRepository.getMaritalList().then((response) => {
                    if (response || response.data || response.data.data) {
                        this.maritalOptions = response.data;
                    } else {
                        console.error("Invalid response structure:", response.data);
                    }
                })
                    .catch((error) => {
                        console.error("Error fetching marital data:", error);
                    });
            },
            professionData() {
                apiRepository
                    .getProfession()
                    .then((response) => {
                        if (response || response.data || response.data.data) {
                            this.professionOption = response.data;
                        } else {
                            console.error("Invalid response structure:", response.data);
                        }
                    })
                    .catch((error) => {
                        console.error("Error fetching profession data:", error);
                    });
            },
            countryData() {
                apiRepository
                    .getCountry()
                    .then((response) => {
                        if (response || response.data || response.data.data) {
                            this.placeOfBirth = response.data;
                        } else {
                            console.error("Invalid response structure:", response.data);
                        }
                    })
                    .catch((error) => {
                        console.error("Error fetching profession data:", error);
                    });
            },
            genderData() {
                apiRepository.getGender().then((response) => {
                    if (response || response.data || response.data.data) {
                        this.genderOptions = response.data;
                    }
                });
            },
            getInputState(value) {
                if (value === '') return false;
                if (typeof value === 'string') return value.trim().length > 0;
                return !!value;
            },
            showError(value) {
                return value === '' || (typeof value === 'string' && value.trim() === '');
            },
        },
    };
</script>
<style scoped>
    /* Add any scoped styles if needed */
    .custom-file-input {
        padding: 5px;
        border: 1px solid #077747;
        border-radius: 5px;
        width: 112px;
    }

    .personal-file-input {
        padding: 5px;
        border: 1px solid #077747;
        border-radius: 5px;
        background-color: #ffffff;
    }
</style>
